module.exports = __webpack_public_path__ + "static/media/cross-white.fabab508.svg";